import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decimalSeparator'
})
export class DecimalSeparatorPipe implements PipeTransform {

  transform(): number {
    return 3;
  }


}
